import { render, staticRenderFns } from "./App.vue?vue&type=template&id=fe2fecee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=fe2fecee&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.store/@vue+cli-service@5.0.8/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports